package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.TestGraph
import com.neurobs.ccabserver.administrator.view.ChartView
import com.neurobs.js.controller.{AdminPanelController, AdminPanelDelegate}
import com.neurobs.js.dom.ElementFactory.PanelView
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom.{CollapsibleBox, ElementFactory}
import com.neurobs.js.dom.Grid._
import com.neurobs.js.view.{Container, Gui}
import io.circe.parser
import io.circe.generic.auto._
import org.scalajs.dom.html.TextArea
import org.scalajs.dom.raw.Event
import scalatags.JsDom.all._

class ChartTestController(gui: Gui) extends AdminPanelController{
	private val chartDiv = div.render

	private def chart(data: String): Unit = {
		chartDiv.innerHTML = ""

		import com.neurobs.ccab.MessageData._
		parser.decode[TestGraph](data) match {
			case Left(_) => chartDiv.appendChild(span("Invalid data").render)
			case Right(obj) => chartDiv.appendChild(ChartView.draw(obj, divStyle = "width: 50em;"))
		}
	}

	override def container: Container = {
		val panel = new PanelView(title = "Chart Test", showRefresh = false, fullWidth = true)
		val closeButton = ElementFactory.makeLink(text = "Close")
		closeButton.onclick = (_:Event) => delegate.foreach(_.close())
		panel.setRightCorner(closeButton)

		//val d = new TestExaminerCommentControllerDelegate
		//val c = new ExaminerCommentController(None, d, gui)
		//d.controller = Some(c)
		//panel.grid.addRow(c.container)

		panel.grid.addRow(span("Enter graph object only ({\"title\": ..., \"type\": ...})").render)

		val textBox: TextArea = textarea(style := "height: 10em; width: 30em;").render
		panel.grid.addRow(textBox)
		val chartButton = button("Chart").render
		chartButton.onclick = (_:Event) => chart(textBox.value)
		panel.grid.addRow(chartButton)
		panel.grid.addRow(chartDiv)
		panel.container
	}
}
